import React from 'react';
import Callout from 'src/components/InformationCallout/Callout';
import calcomLogo from '../../calcom-logo.svg';
import './calcom-scheduling-confirmation-note.scss';

const CalcomSchedulingConfirmationNote = () => {
  return (
    <Callout
      variant="info"
      title={
        <span className="calcom-scheduling-confirmation-note-title">
          <img
            className="calcom-scheduling-confirmation-note-logo"
            src={calcomLogo}
            alt="Cal.com"
          />
          Homeowners will self-schedule on Cal.com
        </span>
      }
      subtitle={
        <>
          When you confirm, Juniper emails the selected homeowners the booking
          link above. They pick their own walkthrough time on Cal.com from your
          live availability — you&apos;re not setting the time here, and the
          booking is then managed on Cal.com&apos;s end.
        </>
      }
    />
  );
};

export default CalcomSchedulingConfirmationNote;